import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { entityStateZodSchema } from "@@/shared/entity-status";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { translation } from "@@/shared/translations/translation";
import type { Except } from "type-fest";
import { z } from "zod";
import { iCalImportIdFactory, iCalImportIdZodSchema } from "./ical-import-id";

const supportedICalSources = [
    {
        type: "GENERIC",
        name: translation({ sv: "Generell", en: "Generic" }),
    },
    {
        type: "BOOKING.COM",
        name: translation({ sv: "Booking.com", en: "Booking.com" }),
    },
    {
        type: "AIRBNB",
        name: translation({ sv: "Airbnb", en: "Airbnb" }),
    },
    {
        type: "SIRVOY",
        name: translation({ sv: "Sirvoy", en: "Sirvoy" }),
    },
] as const;

const iCalImportSourceZodSchema = z.union([
    z.literal("GENERIC"),
    z.literal("BOOKING.COM"),
    z.literal("AIRBNB"),
    z.literal("SIRVOY"),
]);

type iCalImportSourceType = z.infer<typeof iCalImportSourceZodSchema>;

const iCalImportChannelZodObject = z.object({
    _id: iCalImportIdZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("ICAL_IMPORT_CHANNEL"),
    _status: entityStateZodSchema,
    providerId: providerIdZodSchema,
    source: iCalImportSourceZodSchema,
    targetUrl: z.string(),
    targetResource: resourceIdZodSchema,
});

type ICalImportChannel = z.infer<typeof iCalImportChannelZodObject>;

type FactoryParams = Except<
    ICalImportChannel,
    "_id" | "_createdAt" | "_type" | "_status"
>;
const iCalImportFactory = (params: FactoryParams): ICalImportChannel => {
    return {
        ...params,
        _id: iCalImportIdFactory(),
        _createdAt: nowIsoAndUnix(),
        _type: "ICAL_IMPORT_CHANNEL",
        _status: "ACTIVE",
    };
};

export {
    iCalImportChannelZodObject,
    iCalImportFactory,
    iCalImportIdFactory,
    iCalImportIdZodSchema,
    iCalImportSourceZodSchema,
    supportedICalSources,
};
export type { ICalImportChannel, iCalImportSourceType };
